<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
@import './assets/css/font-awesome.min.css';
@import './assets/css/login.css';
@import './assets/css/mdm-ui.css';
@import './assets/css/v-data-table.css';
@import './assets/css/v-calendar.css';
@import './assets//css/materialdesignicons.min.css';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

/**
  date가 움직이는 것 방지
*/
.date-input {
  height: 24px;
  border: 1px solid #ccc;
  padding: 4px 4px 4px 6px;
}
</style>
